/* ============================================================
   CONFIG — Sirf yahan product IDs aur collections add/remove karo
   ============================================================ */
window.HQ_TARGET_PRODUCT_IDS = [
  '9424472768766',
  '9415320305918',
  '9415323844862',
  '9415305724158',
  '9414939902206',
  '9415040893182',
  '9415324467454',
  '9415317192958',
  '9415314374910',
  '9107783352574',
  '9414731366654',
  '9332304019710',
  '9107784990974',
  '9107784466686',
  '9107783680254',
  '9107782435070'
];

// Collection ka handle (URL wala, e.g. /collections/wedding-invitations)
// YA collection ka title (e.g. 'Wedding Invitations') — dono chalte hain.
// Capital/small letters se farq nahi parta.
window.HQ_TARGET_COLLECTIONS = [
  'thesignaturecollection',
  // 'Save The Dates'
];

function hqNorm(s) {
  return String(s).trim().toLowerCase();
}

const hqCollectionsCache = {}; // product-id -> [handles + titles] (lowercase)

function hqProductCollections(id, section) {
  if (hqCollectionsCache[id]) return hqCollectionsCache[id];

  const el =
    (section && section.querySelector('[data-hq-collections]')) ||
    document.querySelector('[data-hq-collections][data-product-id="' + id + '"]');
  if (!el) return null; // abhi DOM me nahi aaya → baad me dobara check hoga

  let list = [];
  try {
    list = JSON.parse(el.getAttribute('data-hq-collections')) || [];
  } catch (e) {}

  hqCollectionsCache[id] = list.map(hqNorm);
  return hqCollectionsCache[id];
}

function hqIsTargetProduct(id, section) {
  id = String(id);
  if (window.HQ_TARGET_PRODUCT_IDS.indexOf(id) !== -1) return true;

  const wanted = (window.HQ_TARGET_COLLECTIONS || []).map(hqNorm);
  if (!wanted.length) return false;

  const cols = hqProductCollections(id, section);
  if (!cols) return false;

  return cols.some(function (c) {
    return wanted.indexOf(c) !== -1;
  });
}


/* ============================================================
   SCRIPT 1 — Live total (variant price × Quantity option)
   Variant ab user ke selected options se turant nikalta hai,
   Dawn ke fetch ka wait nahi karta → koi glitch nahi
   ============================================================ */
(function () {
  const productCache = {};          // product-id -> product JSON | 'loading' | 'failed'
  const moneyCache = new WeakMap(); // section -> money format parts

  /* ---------- Money formatting ---------- */
  function moneyParts(text) {
    const str = String(text);
    const m = str.match(/\d(?:[\d.,\s ]*\d)?/);
    if (!m) return null;

    const numeric = m[0];
    const prefix = str.slice(0, m.index);
    const suffix = str.slice(m.index + numeric.length);

    const dec = numeric.match(/([.,])(\d{2})$/);
    const decimalSep = dec ? dec[1] : '';
    const thousandsSep = decimalSep === ',' ? '.' : ',';

    return { prefix, suffix, decimalSep, thousandsSep };
  }

  function format(cents, p) {
    const amount = cents / 100;
    let intPart;
    let decPart = '';

    if (p.decimalSep) {
      const fixed = amount.toFixed(2);
      intPart = fixed.slice(0, -3);
      decPart = p.decimalSep + fixed.slice(-2);
    } else {
      intPart = String(Math.round(amount));
    }

    intPart = intPart.replace(/\B(?=(\d{3})+(?!\d))/g, p.thousandsSep);
    return p.prefix + intPart + decPart + p.suffix;
  }

  function getMoneyParts(section) {
    const priceEl =
      section.querySelector('.price__regular .price-item--regular') ||
      section.querySelector('.price .price-item--sale');

    if (priceEl) {
      const parts = moneyParts(priceEl.textContent.trim());
      if (parts) {
        moneyCache.set(section, parts);
        return parts;
      }
    }
    // Transition ke dauran price text "Sold out" wagaira ho to cached format use karo
    return moneyCache.get(section) || null;
  }

  /* ---------- Product JSON (saare variants) ---------- */
  function loadProduct(section, pid) {
    const cached = productCache[pid];
    if (cached && typeof cached === 'object') return cached;
    if (cached === 'loading' || cached === 'failed') return null;

    const host =
      section.closest('product-info') || section.closest('[data-url]');
    let url = host && host.dataset.url;

    if (!url) {
      const m = location.pathname.match(/^(.*\/products\/[^/?#]+)/);
      url = m ? m[1] : null;
    }
    if (!url) {
      productCache[pid] = 'failed';
      return null;
    }

    productCache[pid] = 'loading';
    fetch(url.split('?')[0] + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function (product) {
        productCache[pid] = product;
        schedule();
      })
      .catch(function () {
        productCache[pid] = 'failed';
      });

    return null;
  }

  /* ---------- Selected options DOM se ---------- */
  function selectedOptions(section) {
    const out = [];
    const scope = section.querySelector('variant-selects, variant-radios');

    if (scope) {
      scope
        .querySelectorAll('select[name^="options["], fieldset')
        .forEach(function (el) {
          if (el.tagName === 'SELECT') {
            out.push(el.value);
          } else {
            const checked = el.querySelector('input[type="radio"]:checked');
            if (checked) out.push(checked.value);
          }
        });
    } else {
      section
        .querySelectorAll('select[name^="options["]')
        .forEach(function (el) {
          out.push(el.value);
        });
    }

    return out;
  }

  /* ---------- Fallback: purana tareeqa (sirf jab product JSON na mile) ---------- */
  function variantFromDom(section) {
    const idInput = section.querySelector(
      'form[data-type="add-to-cart-form"] input[name="id"]'
    );
    const id = idInput ? idInput.value : '';
    const nodes = section.querySelectorAll('script[type="application/json"]');
    let fallback = null;

    for (let i = 0; i < nodes.length; i++) {
      let data;
      try {
        data = JSON.parse(nodes[i].textContent);
      } catch (e) {
        continue;
      }

      const list = Array.isArray(data) ? data : [data];
      for (let j = 0; j < list.length; j++) {
        const v = list[j];
        if (!v || typeof v.price !== 'number' || !v.id) continue;
        if (id && String(v.id) === String(id)) return v;
        if (!fallback) fallback = v;
      }
    }

    return id ? null : fallback;
  }

  /* ---------- Sahi variant ---------- */
  function resolveVariant(section, pid) {
    const product = loadProduct(section, pid);

    if (product) {
      const opts = selectedOptions(section);
      if (opts.length === product.options.length) {
        const match = product.variants.find(function (v) {
          return v.options.every(function (o, i) {
            return o === opts[i];
          });
        });
        return match || null; // unavailable combination → box hide
      }
    }

    // JSON abhi load ho raha hai ya fail ho gaya → DOM fallback
    return variantFromDom(section);
  }

  /* ---------- Render ---------- */
  function render(section, variant, qty) {
    let box = section.querySelector('.hq-total');

    if (!variant) {
      if (box) box.remove();
      return;
    }

    const parts = getMoneyParts(section);
    if (!parts) return;

    if (!box) {
      const anchor =
        section.querySelector('[id^="price-"]') ||
        section.querySelector('.price');
      if (!anchor) return;

      box = document.createElement('div');
      box.className = 'hq-total';
      box.style.marginTop = '6px';
      box.style.lineHeight = '1.4';
      anchor.insertAdjacentElement('afterend', box);
    }

    const html =
      '<span class="hq-total__value">' +
      format(variant.price * qty, parts) +
      '</span>';

    if (box.innerHTML !== html) box.innerHTML = html;
  }

  function syncSection(section) {
    const form = section.querySelector('form[data-type="add-to-cart-form"]');
    const pid = form && form.querySelector('input[name="product-id"]');
    if (!pid || !hqIsTargetProduct(pid.value, section)) return;

    const select = section.querySelector('select[name="options[Quantity]"]');
    if (!select) return;

    const qty = parseInt(select.value, 10);
    if (!Number.isInteger(qty) || qty < 1) return;

    const input = section.querySelector(
      'input.quantity__input[name="quantity"]'
    );
    if (input && parseInt(input.value, 10) !== qty) {
      input.value = qty;
      input.setAttribute('value', qty);
      input.dispatchEvent(new Event('input', { bubbles: true }));
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }

    render(section, resolveVariant(section, String(pid.value)), qty);
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      document
        .querySelectorAll('.product__info-container')
        .forEach(syncSection);
    });
  }

  schedule();

  // Option change pe turant render
  document.addEventListener(
    'change',
    function (e) {
      if (
        e.target.matches &&
        e.target.matches(
          'select[name^="options["], variant-selects input[type="radio"], variant-radios input[type="radio"]'
        )
      ) {
        schedule();
      }
    },
    true
  );

  // Dawn section re-render kare to box wapas lagane ke liye
  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true
  });
})();


/* ============================================================
   SCRIPT 2 — Customify popup quantity = selected Quantity option
   ============================================================ */
(function () {
  // Page pe jo bhi target product ka form mile, uska section return karo
  function getTargetSection() {
    const pids = document.querySelectorAll(
      'form[data-type="add-to-cart-form"] input[name="product-id"]'
    );
    for (let i = 0; i < pids.length; i++) {
      const section = pids[i].closest('.product__info-container');
      if (section && hqIsTargetProduct(pids[i].value, section)) return section;
    }
    return null;
  }

  function getSelectedQty() {
    const section = getTargetSection();
    if (!section) return null;

    const select = section.querySelector('select[name="options[Quantity]"]');
    if (!select) return null;

    const qty = parseInt(select.value, 10);
    return Number.isInteger(qty) && qty > 0 ? qty : null;
  }

  function setValue(field, want) {
    field.value = want;
    field.setAttribute('value', want);
  }

  function applyQty(field, qty) {
    const want = String(qty);
    if (field.value === want) return;

    setValue(field, want);

    if (typeof window.pplrqty === 'function') {
      try {
        window.pplrqty(true, field, 1);
      } catch (e) {}
      if (field.value !== want) setValue(field, want);
    }

    field.dispatchEvent(new Event('input', { bubbles: true }));
    field.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function fillPopup() {
    const qty = getSelectedQty();
    if (!qty) return;
    const want = String(qty);

    document
      .querySelectorAll('.pplr_ex_inner input.q_fi[name="quantity"]')
      .forEach(function (field) {
        if (field.dataset.hqQty === want) return;
        applyQty(field, qty);
        field.dataset.hqQty = want;
      });
  }

  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      fillPopup();
    });
  }

  new MutationObserver(schedule).observe(document.body, {
    childList: true,
    subtree: true
  });

  document.addEventListener(
    'click',
    function (e) {
      if (!e.target.closest('.ptc_button, .pplr-btn, .pplr-c-button')) return;
      [50, 200, 500, 900, 1500].forEach(function (ms) {
        setTimeout(fillPopup, ms);
      });
    },
    true
  );

  document.addEventListener(
    'change',
    function (e) {
      if (
        e.target.matches &&
        e.target.matches('select[name="options[Quantity]"]')
      ) {
        document.querySelectorAll('[data-hq-qty]').forEach(function (f) {
          delete f.dataset.hqQty;
        });
        setTimeout(fillPopup, 100);
      }
    },
    true
  );

  fillPopup();
})();